import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBBib_l5wHwhshtuL1BHfws9hj9klFPd2c",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "mariana-fitness.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "mariana-fitness",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "mariana-fitness.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "19555103136",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:19555103136:web:4351b09a84927fc188f4c5",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-5MENY9GRYK"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// ❌ Se eliminó 'window.myAuth = auth;' por seguridad

export { auth, db, storage };